import React from 'react'

import { Box, Container } from '@mui/material'

import { Seo } from 'src/components/seo/Seo'

import { SliderMain, TitleMain, Benefits, MoreInfo, SeoIntroLinks } from './parts'

import styles from './main.module.scss'

export const Main: React.FC = () => {
  return (
    <Box>
      <Seo
        title='Вентиляція та комплектуючі'
        description='VentBudEngineering — комплектуючі для систем вентиляції та кондиціонування повітря: решітки, дифузори, повітропроводи, монтаж. Київ та Україна.'
      />
      <Container>
        <TitleMain />
      </Container>
      <Box className={styles.block}>
        <Container>
          <SliderMain />
        </Container>
      </Box>
      <Box className={styles.block}>
        <Container>
          <Benefits />
        </Container>
      </Box>
      <Box className={styles.block}>
        <Container>
          <SeoIntroLinks />
        </Container>
      </Box>
      <Box className={styles.block}>
        <MoreInfo />
      </Box>
    </Box>
  )
}
